import React from 'react';
import IconButton from 'material-ui/IconButton'
import Menu, { MenuItem } from 'material-ui/Menu';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';

const DragHandle = SortableHandle(() =>
    <i className="zmdi zmdi-menu draggable-icon" style={{ fontSize: 25 }} />);

class SortableUser extends React.Component {
    render() {
        // console.log('DataTable', this.state.data)
        const n = this.props.user
        return (

            <TableRow hover role="checkbox">
                <TableCell padding="checkbox">
                    <DragHandle />
                </TableCell>
                <TableCell padding="none">{n.userId}</TableCell>
                <TableCell padding="none">{n.userName}</TableCell>
                <TableCell padding="none">{n.emailId}</TableCell>
            </TableRow>

        );
    }
}

export default SortableElement(SortableUser);


// WEBPACK FOOTER //
// ./app/userdetails/userorder/sortableuser.js